(function() {
  'use strict';

  let blockRedirect = false;

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function() {
    if (blockRedirect && arguments[2] && arguments[2].includes('/cart')) {
      return;
    }
    return originalPushState.apply(this, arguments);
  };

  history.replaceState = function() {
    if (blockRedirect && arguments[2] && arguments[2].includes('/cart')) {
      return;
    }
    return originalReplaceState.apply(this, arguments);
  };

  document.addEventListener('click', function(e) {
    if (!blockRedirect) return;

    const link = e.target.closest('a');
    if (link && link.href && link.href.includes('/cart')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);

  function attachButtonListener() {
    const btn = document.querySelector('#bundle-sticky_submit');

    if (!btn) {
      return false;
    }

    if (btn.dataset.fixedBundle) {
      return true;
    }

    btn.addEventListener('click', function(e) {
      blockRedirect = true;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        const formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (window.snapcart && window.snapcart.openCart) {
            window.snapcart.openCart();
          }

          blockRedirect = false;
        })
        .catch(function(err) {
          blockRedirect = false;
        });
      } else {
        blockRedirect = false;
      }

      return false;
    }, true);

    btn.dataset.fixedBundle = 'true';
    return true;
  }

  const delays = [0, 100, 300, 500, 800, 1000, 1500, 2000, 2500, 3000, 4000, 5000];
  delays.forEach(function(delay) {
    setTimeout(attachButtonListener, delay);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachButtonListener);
  }

  const observer = new MutationObserver(function() {
    const btn = document.querySelector('#bundle-sticky_submit');
    if (btn && !btn.dataset.fixedBundle) {
      attachButtonListener();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
